import {useState} from 'react'
import {Alert, Grid, Link, Stack} from '@mui/material'
import {getLocalDate} from '../../../utils/utilities'
import {getApiHookParams} from '../../../auth'
import {PAUSED_EXPLANATION, isPaused} from '../checkInLifecycle'
import ParticipationBySchool from './ParticipationBySchool'
import {eiSurveyUrl} from '../../../utils/eiLinks'

export default function CheckInInfo({data}) {
  const {isMat} = getApiHookParams()
  const [showParticipationBySchool, setShowParticipationBySchool] =
    useState(false)

  if (data?.groupCycleStatus === 2)
    return (
      <Grid container spacing={1}>
        <Grid item lg={3} md={3} sm={6} xs={12}>
          <div className="current-checkin-survey">
            <h3>
              <strong>Published </strong>
            </h3>
            <Stack direction="column" spacing={1} mt={2}>
              <div>
                Launched on:{' '}
                <strong>{getLocalDate(data.checkIn.startDate)}</strong>
              </div>
              <div></div>
            </Stack>
          </div>
        </Grid>
      </Grid>
    )

  return (
    <Grid container spacing={1} mt={2} mb={3}>
      {data?.live && (
        <Grid 
          item lg={3} md={3} sm={6} xs={12}
          borderRight={1}
          borderColor={'#e2e2e2'}
          pb={5}
          className="preview-section"
        >
          <div className="current-checkin-survey">
            <h3>
              <strong>{data?.liveOrClosed} Check-In Survey</strong>
            </h3>
            <Stack direction="column" spacing={1} mt={2}>
              <div>
                Launched on:{' '}
                <strong>
                  {getLocalDate(data.live?.groupCycles[0]?.startDate)}
                </strong>
              </div>
              <div>
                {data?.liveOrClosed === 'Last' ? 'Ended on:' : 'Will End on'}{' '}
                <strong>
                  {getLocalDate(data.live?.groupCycles[0]?.endDate)}
                </strong>
              </div>
              {isPaused(data?.checkIn?.status) && (
                <Alert severity="warning">
                  <strong>Paused.</strong> {PAUSED_EXPLANATION}
                </Alert>
              )}
            </Stack>
          </div>
        </Grid>
      )}
      {data?.next?.groupCycles && (
        <Grid 
          item lg={3} md={3} sm={6} xs={12}
          borderRight={1}
          borderColor={'#e2e2e2'}
          pb={5}
          className="preview-section"
        >
          <div className="next-checkin-survey">
            <h3>
              <strong>Next Check-In Survey</strong>
            </h3>
            <Stack direction="column" spacing={1} mt={2}>
              <div>
                Launched on:{' '}
                <strong>
                  {data.next?.groupCycles[0]?.startDate &&
                    getLocalDate(data.next?.groupCycles[0]?.startDate)}
                </strong>
              </div>
              <div>
                Will End on:{' '}
                <strong>
                  {data.next?.groupCycles[0]?.endDate &&
                    getLocalDate(data.next?.groupCycles[0]?.endDate)}
                </strong>
              </div>
            </Stack>
          </div>
        </Grid>
      )}
      {data?.live && (
        <Grid 
          item lg={3} md={3} sm={6} xs={12}
          borderRight={1}
          borderColor={'#e2e2e2'}
          pb={5}
          className="preview-section"
        >
          <div className="checkin-parti-rate">
            <h3>
              <strong>Participation Rate</strong>
            </h3>
            <div className="paticipation-rate-value">{data.participation}%</div>
            <div className="checkin-analyse">
              <Link
                href="#"
                underline="always"
                color="#007A7A"
                className="view-participation-rate"
                onClick={e => {
                  window.open(
                    eiSurveyUrl(data?.live.groupCycles[0]?.id),
                    '_blank'
                  )
                }}
              >
                View Participation Rate
              </Link>
            </div>
            {isMat && (
              <div className="checkin-analyse">
                <Link
                  component="button"
                  underline="always"
                  className="view-participation-rate"
                  color="#007A7A"                  
                  onClick={() => setShowParticipationBySchool(true)}                  
                >
                  By school
                </Link>
              </div>
            )}
          </div>
        </Grid>
      )}
      {data?.live && (
        <Grid 
          item lg={3} md={3} sm={6} xs={12}          
          pb={5}
          className="preview-section"
        >
          <div className="checkin-survey-analyse">
            <h3>
              <strong>Analyse Check-In Surveys</strong>
            </h3>
            <div className="checkin-analyse">
              <Link
                href="#"
                underline="always"
                color="#007A7A"
                className="view-participation-rate"
                onClick={e => {
                  window.open(
                    eiSurveyUrl(data?.live.groupCycles[0]?.id),
                    '_blank'
                  )
                }}
                
              >
                View Analyse Results
              </Link>
            </div>
          </div>
        </Grid>
      )}
      {isMat && (
        <ParticipationBySchool
          checkInId={data?.checkIn?.id}
          open={showParticipationBySchool}
          onClose={() => setShowParticipationBySchool(false)}
        />
      )}
    </Grid>
  )
}
